<template>
  <div class="page">
    <Menu :curName="'祈山名师'"/>
    <div class="tContent">
      <div class="header">
        <div class="left">
          <img :src="teacherInfo.avatar" alt />
        </div>
        <div class="right">
          <p class="name">{{teacherInfo.name}}</p>
          <div class="desc" v-html="teacherInfo.brief_desc"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script> 
import Menu from "@/components/Menu.vue";
import { teacherById } from "@/api/teacher.js";

export default {
  data() {
    return {
      teacherInfo: {}
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
       const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      teacherById(this.$route.params.id).then(resp => {
        loading.close();
        if (resp != -1) {
          this.teacherInfo = resp;
        }
      });
    }
  },
  components: {
    Menu
  }
};
</script>
<style lang="scss" scoped>
.tContent{width: 1200px;margin: 20px auto;display: flex;flex-direction:column;
    .header{
        display: flex;flex-direction: row;justify-content: flex-start;padding-bottom:20px;
        .left{padding: 10px;margin-right:20px;
            height: 210px;overflow: hidden;
            img{display: block;border-radius: 15px;height: auto;width: 210px;border-radius: 210px;}
        }
        .right{
            display: flex;flex-direction:column;flex:1;
            .name{font-size: 2.4em;color: #313131;}
            .desc{
              padding: 20px 0;color: #3a3a3a;font-size: 1.6em;line-height: 30px;
            }
        }
    }
   
}
</style>